/** Built-in value references. */
var Uint8Array = global.Uint8Array;

module.exports = Uint8Array;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Uint8Array.js
 ** module id = 257
 ** module chunks = 0
 **/